import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import ModalAddPic from './ModalAddPic';
import Stepper from 'react-stepper-horizontal';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import {Button} from 'react-bootstrap';
import Select from 'react-select';
import {Form} from 'react-bootstrap';
import * as AuthService from '../../../services/auth';
import {useStateWithCallbackLazy} from 'use-state-with-callback';
import {SelectedBox} from '../MapElement';
import {PfImage} from '@profabric/react-components';
import styled from 'styled-components';
import {logoutUser} from '@store/reducers/auth';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import DirectChat from '../DirectChat';
import PhotoStamp from '../PhotoStamp';
import Card from 'react-bootstrap/Card';
import {useSelector} from 'react-redux';
import {toast} from 'react-toastify';

export default function ModalRecost(props) {
  const user = useSelector((state) => state.auth.currentUser);
  useEffect(() => {
    if (Object.keys(props.dropdowns).length !== 0) {
      console.log(props.dropdowns);
      setDropdownCostcenter(props.dropdowns.COSTCENTER);
      setDropdownCompany(props.dropdowns.COMPANY);
    }
  }, [props.dropdowns]);

  useEffect(() => {
    console.log('CHANGE');
    console.log(props.item);
    if (props.item) {
      downloadCrWs();
      downloadChatWs(props.item.planid);
      downloadPhotoWs(props.item.planid);
      downloadPathWs(props.item.planid);
      setDropdownApvIbc(props.item.apvPlanIbcid);
      setDropdownApvActual(props.item.apvActualid);
      setPlan((prevState) => ({
        ...prevState,
        vehicleid: props.item.vehicleid,
        distanceActual: props.item.distanceActual / 1000,
        totaCostActual: props.item.totaCostActual,
        rate: props.item.rate
      }));
      //   downloadApvWs(props.item.planid);
    }
  }, [props.item]);

  const StyledUserImage = styled(PfImage)``;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const downloadCrWs = async () => {
    try {
      const show = await AuthService.downloadCrWs();
      if (show.error) toast.error(show.error);
      setShow(show.value);
    } catch (error) {}
  };

  const uploadPicWs = async (input, file) => {
    try {
      const photo = await AuthService.uploadPicWs(input, file);
      setPhoto(photo);
      setShowMd4(false);
      if (photo.error) toast.error(photo.error);
    } catch (error) {}
  };

  const downloadPhotoWs = async (planid) => {
    try {
      const photo = await AuthService.downloadPhoto(planid, 'plan');
      console.log(photo);
      if (photo.error) throw 'timeout';
      setPhoto(photo);
    } catch (error) {
      console.log('exit photo');
      props.onHide();
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };

  const downloadPathWs = async (planid) => {
    try {
      const path = await AuthService.downloadPathRecost(planid);
      console.log(path);
      if (path.error) throw 'timeout';
      setApprovePath(
        path.map((e, i) => {
          return {
            ...e,
            href: '#',
            onClick: (e) => {
              e.preventDefault();
              onSendMessage(props.item ? `#APV-${i}` : 'ERROR');
              console.log('onClick', i);
            }
          };
        })
      );

      //ตั้งค่า panel
      setPanel((prevState) => ({
        ...prevState,
        isMe: props.item.staffid === user.ID_EMP,
        isEditable: false,
        isCancelable:
          path.filter((e) => e.status === '').length == path.length - 1,
        isApprovable: path.find((e) => e.status === '')
          ? path.find((e) => e.status === '').members.includes(user.ID_EMP)
          : false,
        isRejectable: path.find((e) => e.status === '')
          ? path.find((e) => e.status === '').members.includes(user.ID_EMP)
          : false
      }));
    } catch (error) {
      console.log('exit path');
      props.onHide();
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };

  const downloadChatWs = async (planid) => {
    try {
      const chats = await AuthService.downloadChat(planid);
      if (chats.error) throw 'timeout';
      setChat(chats);
    } catch (error) {
      console.log('exit chat');
      props.onHide();
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };
  const uploadChatWs = async (planid, message) => {
    try {
      const chats = await AuthService.uploadChat(planid, message);
      if (chats.error) throw 'timeout';
      setChat(chats);
    } catch (error) {
      console.log('exit chat');
      props.onHide();
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };
  const updatePlanWs = async (input) => {
    try {
      const result = await AuthService.updatePlan(input);
      if (result.result === 'SUCCESS') toast.success('ปรับปรุงข้อมูลแล้ว');
      else toast.error('ปรับปรุงข้อมูลผิดพลาด');
    } catch (error) {}
  };
  const updatePlanApproveWs = async (input) => {
    try {
      const result = await AuthService.updatePlanApprove(input);
      if (result.result === 'SUCCESS') toast.success('ปรับปรุงข้อมูลแล้ว');
      else toast.error('ปรับปรุงข้อมูลผิดพลาด');
      await props.onRefresh(input.planid);
    } catch (error) {}
  };
  const [key, setKey] = useState('plan');
  const [show, setShow] = useState(false);
  const [panel, setPanel] = useState({
    isMe: false,
    isCancelable: false,
    isEditable: false,
    isApprovable: false,
    isRejectable: false
  });
  const [style, setStyle] = useState('lightbox');
  const [chat, setChat] = useState([]);
  const [photo, setPhoto] = useState([
    {
      src: `https://cdn-icons-png.flaticon.com/512/911/911033.png`,
      original: `https://cdn-icons-png.flaticon.com/512/911/911033.png`,
      downloadUrl: `https://cdn-icons-png.flaticon.com/512/911/911033.png`,
      caption: `TEMP`,
      alt: `TEMP`
    }
  ]);
  //   const [plan, setPlan] = useState({
  //     vehicleid: {value: '', label: 'เลือกยานพาหนะ'}
  //   });

  const [plan, setPlan] = useState({
    vehicleid: {value: '', label: 'เลือกยานพาหนะ'},
    totalExpend: 0,
    distanceActual: 0,
    totaCostActual: 0,
    rate: 0
  });
  const [showMd4, setShowMd4] = useState(false);

  const [approvePath, setApprovePath] = useState([]);
  const [dropdownCompany, setDropdownCompany] = useState({DATA: []});
  const [dropdownCostcenter, setDropdownCostcenter] = useState({DATA: []});
  const [dropdownApvIbc, setDropdownApvIbc] = useState({});
  const [dropdownApvActual, setDropdownApvActual] = useState({});
  const [error, setError] = useState('');

  const onAgree = async () => {
    await updatePlanApproveWs({
      planid: props.item.planid,
      status: 'approve',
      system: props.item.system,
    });
    await props.onRefresh(props.item.planid);
    props.onHide();
  };

  const onReject = async () => {
    await updatePlanApproveWs({
      planid: props.item.planid,
      status: 'reject',
      system: props.item.system,
    });
    await props.onRefresh(props.item.planid);
    props.onHide();
  };

  const onEdit = async () => {
    await updatePlanApproveWs({
      planid: props.item.planid,
      status: 'edit'
    });
    await updatePlanWs({
      planid: props.item.planid,
      vehicleid: plan.vehicleid
    });
    await props.onRefresh(props.item.planid);
    props.onHide();
  };
  const onCancel = async () => {
    await updatePlanWs({
      planid: props.item.planid,
      status: 'cancel',
      system: props.item.system,
    });
    await props.onRefresh(props.item.planid);
    props.onHide();
  };

  const onUpload = async (file) => {
    if (props.item) {
      let input = {
        planid: props.item.planid
      };
      await uploadPicWs(input, file);
      await props.onRefresh(props.item.planid);
    }
  };

  const onSendMessage = async (message) => {
    if (props.item) {
      await uploadChatWs(props.item.planid, message);
    }
  };

  return (
    <div className="row">
      <Modal
        show={showMd4}
        onHide={() => setShowMd4(false)}
        style={{zIndex: 9999}}
      >
        <Modal.Header closeButton>
          <Modal.Title>อัพโหลดรูปเพิ่มเติม</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalAddPic onUpload={onUpload}></ModalAddPic>
        </Modal.Body>
      </Modal>
      <div className="col-12 col-md-9">
        <Card className="bg-light">
          <Stepper
            size={64}
            activeColor={'#f8f9fa'}
            completeColor={'#f8f9fa'}
            defaultColor={'#f8f9fa'}
            titleFontSize={12}
            circleFontSize={14}
            steps={approvePath}
            activeStep={
              approvePath.filter((e) => e.status === 'approve').length ===
              approvePath.length
                ? approvePath.length - 1
                : approvePath.filter((e) => e.status === 'approve').length
            }
          />
        </Card>
        <Tabs
          id="controlled-tab-example"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3"
        >
          <Tab eventKey="plan" title="ข้อมูล">
            <div className="row">
              <Form.Group className="mb-3 col-md-12">
                <Form.Label>พนักงาน</Form.Label>
                <Form.Control
                  type="text"
                  value={props.item ? props.item.staff : ''}
                  disabled
                />
              </Form.Group>
              <Form.Group className="mb-3 col-md-6">
                <Select
                  isDisabled={props.mode === 'read'}
                  placeholder={'บริษัทรับทราบค่าใช้จ่าย'}
                  value={
                    props.item
                      ? dropdownCompany.DATA.find(
                          (e) =>
                            e.value.toString() === props.item.companyid.value
                        )
                      : {}
                  }
                  options={dropdownCompany.DATA}
                  onChange={(v) => {}}
                />
              </Form.Group>
              <Form.Group className="mb-3 col-md-6">
                <Select
                  isDisabled={props.mode === 'read'}
                  value={
                    props.item
                      ? dropdownCostcenter.DATA.find(
                          (e) => e.value.toString() === props.item.costid.value
                        )
                      : {}
                  }
                  placeholder={'cost center'}
                  options={
                    !props.item
                      ? dropdownCostcenter.DATA
                      : dropdownCostcenter.DATA.filter(
                          (e) =>
                            e.company.toString() === props.item.companyid.value
                        )
                  }
                  onChange={(v) => {}}
                />
              </Form.Group>
              <Form.Group className="mb-3 col-md-6">
                <Select
                  isDisabled={true}
                  value={dropdownApvIbc}
                  placeholder={'เลือก IBC'}
                  options={[]}
                  formatOptionLabel={(e) => (
                    <div className="d-flex">
                      <StyledUserImage
                        src={e.image}
                        fallbackSrc="/img/default-profile.png"
                        width={34}
                        height={34}
                        rounded
                      />
                      <span className="align-self-center ml-2">{e.label}</span>
                    </div>
                  )}
                />
              </Form.Group>
              <Form.Group className="mb-3 col-md-6">
                <Select
                  isDisabled={true}
                  value={dropdownApvActual}
                  placeholder={'เลือกผู้อนุมัติผล'}
                  options={[]}
                  formatOptionLabel={(e) => (
                    <div className="d-flex">
                      <StyledUserImage
                        src={e.image}
                        fallbackSrc="/img/default-profile.png"
                        width={34}
                        height={34}
                        rounded
                      />
                      <span className="align-self-center ml-2">{e.label}</span>
                    </div>
                  )}
                />
              </Form.Group>
              <Form.Group className="mb-3 col-md-12">
                <Form.Control
                  as="textarea"
                  rows="2"
                  placeholder="กรอกเหตุผลประกอบการขอโยกงบ"
                  value={props.item ? props.item.reason : ''}
                />
              </Form.Group>
              <div className="col-6">
                <Card>
                  <Card.Header>งบที่ถูกเลือก</Card.Header>
                  <Card.Body>
                    <div className="col-12">
                      {props.item.budget
                        .filter((ele) => ele.select)
                        .map((e) => (
                          <div className="input-group col-12 m-2">
                            <div className="input-group-prepend">
                              <div
                                className="input-group-text"
                                style={{width: 130}}
                              >
                                {e.month}
                              </div>
                            </div>
                            <input
                              style={{
                                textAlign: 'right',
                                backgroundColor: 'white'
                              }}
                              disabled
                              type="text"
                              className="form-control"
                              value={e.costRemain}
                            />
                          </div>
                        ))}
                    </div>
                  </Card.Body>
                </Card>
              </div>
              <div className="col-6">
                <div className="input-group col-12">
                  <div className="input-group-prepend">
                    <div className="input-group-text" style={{width: 150}}>
                      {'โยกไปเดือน - รวม'}
                    </div>
                  </div>
                  <input
                    style={{
                      textAlign: 'right',
                      backgroundColor: 'white'
                    }}
                    disabled
                    type="text"
                    className="form-control"
                    value={[
                      props.item.yearMonth.slice(0, 4),
                      '-',
                      props.item.yearMonth.slice(4)
                    ].join('')}
                  />
                  <input
                    style={{
                      textAlign: 'right',
                      backgroundColor: 'white'
                    }}
                    disabled
                    type="text"
                    className="form-control"
                    value={props.item.budget
                      .filter((e) => e.select)
                      .reduce(
                        (prev, curr) =>
                          prev + Number(curr.costRemain.replace(/,/g, '')),
                        0
                      )}
                  />
                </div>
              </div>
            </div>
          </Tab>
          <Tab eventKey="gallery" title={`ไฟล์อัพโหลดรูป (${photo.length})`}>
            <PhotoStamp
              images={photo}
              style={style}
              setStyle={setStyle}
            ></PhotoStamp>
          </Tab>
        </Tabs>
        <p className="text-danger col-md-12">{error}</p>
      </div>
      <div className="col-12 col-md-3">
        <DirectChat
          isPublic={
            props.item ? props.item.vehicleid.value === '0' || show : false
          }
          onOpenUpload={setShowMd4}
          panel={panel}
          messages={chat}
          onAgree={onAgree}
          onReject={onReject}
          onEdit={onEdit}
          onCancel={onCancel}
          onSendMessage={onSendMessage}
        ></DirectChat>
      </div>
    </div>
  );
}
